import {
  BookOpenCheckIcon,
  Clock3Icon,
  FileQuestionIcon,
  GraduationCapIcon,
  CalculatorIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export const painPoints: { icon: LucideIcon; text: string }[] = [
  { icon: Clock3Icon, text: 'Sei sveglio a mezzanotte a costruire la scheda di domani da zero.' },
  { icon: FileQuestionIcon, text: 'Uno studente chiede “ma questo a cosa serve?” e ti blocchi.' },
  { icon: GraduationCapIcon, text: 'Nella stessa classe convivono tre livelli diversi e non sai come gestirli.' },
  { icon: CalculatorIcon, text: 'Rispieghi lo stesso passaggio ogni settimana e chi è indietro resta indietro.' },
  { icon: BookOpenCheckIcon, text: 'Non hai budget per i materiali a pagamento e correggi tutto a mano.' },
]
